export const version = "contracts/5.6.0";
//# sourceMappingURL=_version.js.map